export const PUBLIC_ROUTES = new Set<string>([
  "/portal/sign-in",
  "/portal/callback",
  "/admin/sign-in",
  "/admin/sign-up",
  "/admin/callback",
  "/admin/accept-invite",
  "/admin/check-email",
  "/admin/confirmed",
  "/admin/welcome",
  "/admin/welcome/template",
  "/admin/welcome/employee",
  "/admin/welcome/done",
  "/invitation-accept",
  "/portal/accept",
  "/dev/ping",
  "/dev/design-preview",
  "/dev/overview-preview",
  "/dev/organisation-preview",
  "/health",
  "/pricing",
  "/privacy",
  "/terms",
  "/reset-password",
]);

export function isPublicPath(pathname: string): boolean {
  const path = pathname.split("?")[0];

  // Check exact matches
  if (PUBLIC_ROUTES.has(path)) {
    return true;
  }

  // Check dynamic routes
  if (path.startsWith('/share/')) {
    return true;
  }

  return false;
}

/** True for admin-shell routes (used by Layout to pick the app chrome). */
export function isAdminRoute(path: string): boolean {
  return path.startsWith('/admin') ||
         path.startsWith('/dashboard') ||
         path.startsWith('/people') ||
         path.startsWith('/organisation') ||
         path.startsWith('/team') ||
         path.startsWith('/tasks') ||
         path.startsWith('/templates') ||
         path.startsWith('/settings') ||
         path.startsWith('/reports')
}

/** True for employee-portal routes. */
export function isEmployeeRoute(path: string): boolean {
  return path.startsWith('/portal') ||
         path.startsWith('/invitation-accept') ||
         path.startsWith('/my-tasks') ||
         path === '/employee'
}

/**
 * Routes that are spatial workspaces (a canvas, a board) rather than a
 * document/report — AppShell's centered max-width column is right for the
 * latter and wrong for the former, where it just wastes the width the tool
 * actually needs. Used by Layout to opt individual routes out of that
 * constraint without touching it for anyone else.
 */
export function isFullWidthRoute(path: string): boolean {
  return path.startsWith('/organisation')
}
